import {
  Directive,
  ElementRef,
  EventEmitter,
  inject,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { EnvironmentService } from '@core/services/environment.service';

@Directive({
  selector: '[auRecaptcha]',
})
export class RecaptchaDirective implements OnInit, OnDestroy {
  @Output() recaptchaSuccess = new EventEmitter<string>();
  // @Output() recaptchaExpired = new EventEmitter<unknown>();
  // @Output() recaptchaError = new EventEmitter<unknown>();

  private readonly scriptId = 'au-recaptcha';
  widgetId: number | null = null;
  captchaPublicSiteKey: string = '';

  environmentService = inject(EnvironmentService);
  // dom: Document = inject(DOCUMENT);
  ngZone = inject(NgZone);

  constructor(private elementRef: ElementRef) {
    this.captchaPublicSiteKey = this.environmentService.captchaSiteKey;
  }

  ngOnInit() {
    this.registerCaptchaCallback();
    this.addScript();
  }

  public registerCaptchaCallback() {
    (window as any).recaptchaCallback = () => {
      const config = {
        sitekey: this.captchaPublicSiteKey,
        // size: 'invisible',
        callback: this.onSuccessCallback.bind(this),
        // 'error-callback': this.onErrorCallback.bind(this),
        // 'expired-callback': this.onExpiredCallback.bind(this),
      };
      this.widgetId = this.renderCaptcha(config);
    };
  }

  renderCaptcha(config: any): number {
    return (window as any).grecaptcha.render(
      this.elementRef.nativeElement,
      config
    );
  }

  addScript() {
    // if (this.dom.getElementById(this.scriptId) != null) {
    //   return;
    // }

    const script = document.createElement('script');
    script.src =
      'https://www.google.com/recaptcha/api.js?onload=recaptchaCallback&render=explicit';
    script.id = this.scriptId;
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }

  private onSuccessCallback(token: string) {
    this.ngZone.run(() => {
      this.recaptchaSuccess.emit(token);
    });
  }

  // private onErrorCallback() {
  //   this.ngZone.run(() => {
  //     this.recaptchaError.emit();
  //   });
  // }

  // private onExpiredCallback() {
  //   this.ngZone.run(() => {
  //     this.recaptchaExpired.emit();
  //   });
  // }

  ngOnDestroy() {
    this.widgetId = null;
  }
}
